<template>
    <v-container grid-list-md fluid :key="id">
        <v-card class="default_card large mx-0 my-2 pa-2 fill-height sticky-card" elevation="0">
            <v-row no-gutters>
                <v-col class="d-flex headline pl-6 align-center" cols="6">
                    <v-btn-back
                        class="mr-4"
                        @click.stop="$router.push({ name: 'AccountingReviewLayoutsTable' })"
                    >
                    </v-btn-back>
                    <v-text-field-filled
                        v-model="accountingReviewLayoutName"
                        label="Nom"
                        :rules="[(v: any) => !!v || $t('settings.itemRequired')]"
                        :readonly="readOnly || !isAccountingFirmOwner"
                        density="compact"
                        hide-details
                    />
                </v-col>
                <v-col class="d-flex justify-end align-center" cols="6">
                    <v-btn
                        class="mr-2"
                        v-if="displayDuplicate"
                        @click="duplicateAccountingReviewLayout()"
                    >
                        Dupliquer
                    </v-btn>
                    <div v-if="isAccountingFirmOwner">
                        <v-btn-edit
                            v-if="id"
                            @click="upsertAccountingReviewLayout()"
                            :disabled="isValidDisabled"
                        >
                        </v-btn-edit>
                        <v-btn-create
                            v-else
                            @click="upsertAccountingReviewLayout()"
                            :disabled="isValidDisabled"
                        >
                        </v-btn-create>
                    </div>
                </v-col>
            </v-row>
        </v-card>
        <v-row no-gutters class="default_card_wm">
            <v-col cols="8" class="d-flex justify-center align-center">
                <h4>Dossier de révision pour situation intermédiaire</h4>
            </v-col>
            <v-col cols="2" class="d-flex justify-start align-center">
                <v-switch hide-details v-model="forSituation" class="pl-2 mt-0" />
            </v-col>
        </v-row>
        <v-spacer />
        <v-row
            no-gutters
            class="d-flex justify-center"
            :style="'max-height:' + maxHeight + ';' + 'overflow:auto; margin-top: 1vh'"
        >
            <v-col cols="12">
                <v-data-table
                    title
                    :headers="headers"
                    :items="layout"
                    :items-per-page="-1"
                    hide-default-footer
                    class="table"
                >
                    <template v-slot:item="props">
                        <tr :key="props.item.index" v-if="props.item.type === 'cycleTitle'">
                            <td width="5%" />
                            <td width="10%">
                                <div class="d-flex justify-center">
                                    <v-btn-icon
                                        icon="$fa-angle-up"
                                        size="x-small"
                                        color="secondary"
                                        elevation="0"
                                        @click="swapRow(props.index, props.index - 1)"
                                        :disabled="props.index === 0 || !isAccountingFirmOwner"
                                    />
                                    <v-btn-icon
                                        icon="$fa-angle-down"
                                        size="x-small"
                                        color="secondary"
                                        elevation="0"
                                        @click="swapRow(props.index, props.index + 1)"
                                        :disabled="
                                            props.index === layout.length - 1 ||
                                            !isAccountingFirmOwner
                                        "
                                    />
                                </div>
                            </td>
                            <td width="10%" class="text-center">
                                <v-chip
                                    style="min-width: 50px"
                                    size="small"
                                    variant="outlined"
                                    color="primary"
                                >
                                    Titre
                                </v-chip>
                            </td>
                            <td
                                v-if="props.item.cycleTitle"
                                class="text-center"
                                width="50%"
                                style="font-weight: 900"
                            >
                                {{ props.item.cycleTitle }}
                            </td>
                            <td width="10%">
                                <div class="d-flex justify-center">
                                    <v-btn-icon
                                        icon="$oss-edit"
                                        color="secondary"
                                        elevation="0"
                                        @click="editTitleRow(props.index)"
                                        :disabled="readOnly || !isAccountingFirmOwner"
                                        size="x-small"
                                    />
                                </div>
                            </td>
                            <td width="10%">
                                <div class="d-flex justify-center">
                                    <v-btn-trash
                                        @click="removeRow(props.index)"
                                        :disabled="readOnly || !isAccountingFirmOwner"
                                        size="x-small"
                                    />
                                </div>
                            </td>
                            <td width="5%" />
                        </tr>
                        <tr v-else>
                            <td width="5%" />
                            <td width="10%">
                                <div class="d-flex justify-center">
                                    <v-btn-icon
                                        icon="$fa-angle-up"
                                        size="x-small"
                                        color="secondary"
                                        elevation="0"
                                        @click="swapRow(props.index, props.index - 1)"
                                        :disabled="props.index === 0 || !isAccountingFirmOwner"
                                    />
                                    <v-btn-icon
                                        icon="$fa-angle-down"
                                        size="x-small"
                                        color="secondary"
                                        elevation="0"
                                        @click="swapRow(props.index, props.index + 1)"
                                        :disabled="
                                            props.index === layout.length - 1 ||
                                            !isAccountingFirmOwner
                                        "
                                    />
                                </div>
                            </td>
                            <td width="10%" class="text-center">
                                <v-chip color="green" size="small" variant="outlined">
                                    {{
                                        props.item.type !== "ACCOUNTING_REVIEW_MANUAL_CUSTOM"
                                            ? "Contrôle bobbee"
                                            : "Contrôle cabinet"
                                    }}
                                </v-chip>
                            </td>
                            <!-- <td v-if="props.item.title" width="50%" class="text-center">
                                {{ props.item.title }}
                            </td> -->
                            <td width="50%" class="text-center">
                                {{
                                    props.item.title
                                        ? props.item.title
                                        : $t(`audit.${props.item.key}.title`)
                                }}
                            </td>
                            <td width="10%">
                                <div class="d-flex justify-center">
                                    <v-btn-icon
                                        icon="$oss-edit"
                                        v-if="
                                            props.item.type === 'ACCOUNTING_REVIEW_MANUAL_CUSTOM' ||
                                            props.item.cycleTitle
                                        "
                                        elevation="0"
                                        color="secondary"
                                        @click="editAuditRow(props.item, props.index)"
                                        :disabled="
                                            (props.item.type &&
                                                props.item.type !==
                                                    'ACCOUNTING_REVIEW_MANUAL_CUSTOM') ||
                                            !isAccountingFirmOwner
                                        "
                                        size="x-small"
                                    />
                                    <v-btn-icon
                                        icon="$oss-eye"
                                        v-if="props.item.type !== 'ACCOUNTING_REVIEW_MANUAL_CUSTOM'"
                                        color="secondary"
                                        elevation="0"
                                        @click="displaySelectedAudit(props.item)"
                                        size="x-small"
                                    />
                                </div>
                            </td>
                            <td width="10%">
                                <div class="d-flex justify-center">
                                    <v-btn-trash
                                        @click="removeRow(props.index)"
                                        :disabled="readOnly || !isAccountingFirmOwner"
                                        size="x-small"
                                    />
                                </div>
                            </td>
                            <td width="5%" />
                        </tr>
                    </template>
                    <template v-slot:body.append>
                        <tr>
                            <td colspan="7" style="text-align: center">
                                <div class="d-flex justify-center align-center">
                                    <v-btn size="small" @click="toggleAddAuditTitleDialog()">
                                        Ajouter un titre
                                        <v-icon style="padding-bottom: 2.5px">$add</v-icon>
                                    </v-btn>

                                    <v-btn
                                        size="small"
                                        class="ml-4"
                                        @click="toggleAddAuditDialog()"
                                    >
                                        Ajouter un contrôle
                                        <v-icon style="padding-bottom: 2.5px">$add</v-icon>
                                    </v-btn>
                                </div>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <ScopeManager
            v-model="scopeSync"
            v-model:id="scopeId"
            v-model:name="scopeName"
            :readonly="readOnly && !isAccountingFirmOwner"
        />
        <oss-dialog
            v-if="addAuditDialog"
            v-model="addAuditDialog"
            :title="windowTitle()"
            :validTitle="editMode ? 'Enregistrer' : displayMode ? 'Fermer' : 'Ajouter'"
            @valid="
                editMode
                    ? validateModificatedAuditRow()
                    : addAuditDialogStep === 'createAudit' && !displayMode
                      ? validateNewAudit()
                      : displayMode
                        ? toggleAddAuditDialog()
                        : addAuditCheck(newAuditToAdd)
            "
            :valid-disabled="isValidateDisabled()"
            @previous="
                previous();
                readOnly = false;
            "
            :previous-display="displayPreviousButton"
            @close="previous()"
            min-width="1200px"
        >
            <v-window v-model="addAuditDialogStep">
                <v-window-item height="100%" :value="'existingAudits'">
                    <v-row>
                        <v-col cols="3">
                            <v-btn-primary @click="addAuditDialogStep = 'createAudit'">
                                Créer un nouveau contrôle
                            </v-btn-primary>
                        </v-col>
                    </v-row>
                    <AuditChecks
                        :auditCheckTypes="auditCheckTypes"
                        :alreadySelectedAudits="layout"
                        mode="displayOrSelect"
                        @displayExistingAudit="displayExistingAudit($event)"
                        max-height="100%"
                    >
                    </AuditChecks>
                </v-window-item>
                <v-window-item :value="'createAudit'">
                    <AuditCheckEdition
                        v-if="addAuditDialogStep === 'createAudit'"
                        ref="auditCheckEdition"
                        @newAudit="addAuditCheck($event)"
                        @editAudit="modifyAudit($event)"
                        :auditToEdit="auditToEdit"
                        :auditToDisplay="auditToDisplay"
                        :editMode="editMode"
                        :readOnly="readOnly"
                    >
                    </AuditCheckEdition>
                </v-window-item>
            </v-window>
        </oss-dialog>
        <oss-dialog
            v-if="addAuditTitleDialog"
            v-model="addAuditTitleDialog"
            title="Ajout d'un cycle"
            @valid="editMode ? validateModificatedTitleRow() : validateNewTitle()"
            :validTitle="editMode ? 'Enregistrer' : 'Ajouter'"
            :valid-disabled="!newTitle.cycleTitle"
            min-width="1000px"
        >
            <v-card-text class="mt-2">
                <v-row class="mb-3">
                    <v-col cols="2" class="d-flex align-center">
                        <h3>Nom :</h3>
                    </v-col>
                    <v-col cols="9">
                        <v-text-field-filled
                            v-model="newTitle.cycleTitle"
                            hide-details
                            outlined
                            label="Nom du cycle"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="1" />
                </v-row>
            </v-card-text>
        </oss-dialog>
    </v-container>
</template>

<script lang="ts">
import gql from "graphql-tag";
import { Apollo } from "@/decorators";
import crypto from "crypto";
import { User } from "../../store/store";

import ACCOUNTING_REVIEW_LAYOUT from "../../graphql/audit/AccountingReviewLayout.gql";
import EXISTING_AUDIT_CHECKS from "../../graphql/audit/ExistingAuditChecks.gql";
import UPSERT_ACCOUNTING_REVIEW_LAYOUT from "../../graphql/audit/UpsertAccountingReviewLayout.gql";
import UPSERT_AUDIT_CHECK from "../../graphql/audit/UpsertAuditCheck.gql";

import AuditCheckEdition from "../admin/AuditCheckEdition.vue";
import AuditChecks from "../admin/AuditChecks.vue";
import ScopeManager from "../companyScope/ScopeManager.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import { Model } from "vue-facing-decorator";
import { Ref } from "vue-facing-decorator";

@Component({
    components: {
        AuditCheckEdition,
        AuditChecks,
        ScopeManager,
    },
})
export class AccountingReviewLayout extends Vue {
    @Prop({ default: "" }) id: string;
    @Prop({ default: "" }) idToDuplicate: string;

    @Model({ type: String, name: "companyScope" }) scopeSync!: any;

    auditCheckTypes = [
        "ACCOUNTING_REVIEW_AUTO",
        "ACCOUNTING_REVIEW_MANUAL",
        "ACCOUNTING_REVIEW_MANUAL_CUSTOM",
    ];

    accountingReviewLayoutName: string = "";

    addAuditTitleDialog: boolean = false;

    addAuditDialog: boolean = false;

    addAuditDialogWindow: string = "addExistingAudit";

    addAuditDialogStep: string = "addExistingAudit";

    displayMode: boolean = false;

    editMode: boolean = false;

    readOnly: boolean = false;

    index = 0;

    auditToEdit: any = null;

    auditToDisplay: any = null;

    newAuditToAdd: any = null;

    validationForAllAccountingCompany = false;

    newTitle: any = {
        type: "cycleTitle",
        cycleTitle: "",
    };

    headers = [
        {
            title: " ",
            sortable: false,
        },
        {
            title: "Organiser",
            sortable: false,
            align: "center",
            class: "subtitle-2",
        },
        {
            title: "Type",
            sortable: false,
            align: "center",
            class: "subtitle-2",
        },
        {
            title: "Éléments",
            sortable: false,
            align: "center",
            class: "subtitle-2",
        },
        {
            title: "Action",
            sortable: false,
            align: "center",
            class: "subtitle-2",
        },
        {
            title: "Supprimer",
            sortable: false,
            align: "center",
            class: "subtitle-2",
        },
        {
            title: " ",
            sortable: false,
        },
    ];

    importSuccess = false;

    scopeName: string = "";
    scopeId_: string = "";

    get scopeId() {
        if (this.scopeSync?.id) {
            this.scopeId_ = this.scopeSync?.id;
        }
        return this.scopeId_;
    }

    set scopeId(value) {
        this.scopeId_ = value;
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get accountingFirmId() {
        return this.$store.state.user.company.id;
    }

    get clientCompaniesIds() {
        const result = [];
        for (const company of this.currentUser.allAvailableCompanies) {
            result.push(company.id);
        }
        return result;
    }

    get isValidDisabled() {
        if (!this.accountingReviewLayoutName || !this.isAccountingFirmOwner) {
            return true;
        }
        if (!this.scopeId) {
            return true;
        }
        return false;
    }

    get displayDuplicate() {
        if (this.idToDuplicate || !this.id) {
            return false;
        }
        return true;
    }

    get isAccountingFirmOwner() {
        if (
            !this.arlAccountingCompanyOwnerId ||
            this.arlAccountingCompanyOwnerId === this.accountingFirmId
        ) {
            return true;
        }
        return false;
    }

    get displayPreviousButton() {
        if (this.addAuditDialogStep === "existingAudits") {
            return false;
        }
        if (this.displayMode) {
            return false;
        }
        if (this.editMode) {
            return false;
        }
        return true;
    }

    get maxHeight() {
        const innHeight = window.innerHeight;
        const vhHeight = (380 / innHeight) * 100;
        const maxHeight_vh = 100 - vhHeight;

        return maxHeight_vh + "vh";
    }

    // get patternId() {
    //     if (this.$route.params.id) {
    //         return this.$route.params.id
    //     }
    //     return ""
    // }

    @Watch("addAuditDialog")
    closeAddAuditDialog() {
        if (this.addAuditDialog === false) {
            this.index = 0;
            this.editMode = false;
            this.displayMode = false;
            this.addAuditDialogStep = "existingAudits";
            this.readOnly = false;
            this.auditToDisplay = null;
            this.auditToEdit = null;
            this.newAuditToAdd = null;
        }
    }

    @Watch("addAuditTitleDialog")
    closeAddAuditTitleDialog() {
        if (this.addAuditTitleDialog === false) {
            this.newTitle.cycleTitle = "";
            this.index = 0;
            this.editMode = false;
            this.displayMode = false;
        }
    }

    @Watch("idToDuplicate")
    onIdToDuplicateChanged(value, prevValue) {
        if (value && !prevValue) {
            this.accountingReviewLayoutName = "";
            this.scopeId = "";
            this.scopeName = "";
            this.arlAccountingCompanyOwnerId = this.accountingFirmId;
        }
    }

    @Apollo({
        query: EXISTING_AUDIT_CHECKS,
        variables() {
            return {
                accountingFirmId: this.accountingFirmId,
            };
        },
        result({ data, loading }: any) {
            if (data && data.auditChecks) {
                this.existingAudits = data.auditChecks;
            }
        },
    })
    existingAudits: any = [];

    @Apollo({
        query: ACCOUNTING_REVIEW_LAYOUT,
        variables() {
            return {
                id: this.id || this.idToDuplicate,
                accountingFirmId: this.accountingFirmId,
            };
        },
        skip() {
            return !this.existingAudits.length;
        },
        result({ data, loading }: any) {
            if (data?.accountingReviewLayout) {
                if (this.idToDuplicate) {
                    this.onIdToDuplicateChanged(this.idToDuplicate, "");
                } else {
                    this.accountingReviewLayoutName = data.accountingReviewLayout.name;

                    if (data.accountingReviewLayout.companyScope) {
                        this.scopeId = data.accountingReviewLayout.companyScope.id;
                        this.scopeName = data.accountingReviewLayout.companyScope.name;
                        this.arlAccountingCompanyOwnerId =
                            data.accountingReviewLayout.companyScope.accountingCompanyOwner.id;
                    }
                }

                this.forSituation = data.accountingReviewLayout.forSituation;

                for (const item of data.accountingReviewLayout.layout.items) {
                    if (item.type === "cycleTitle") {
                        this.layout.push(item);
                    } else if (item.type === "audit") {
                        const audit = this.existingAudits.find(
                            (existingAudit) => existingAudit.key === item.key,
                        );
                        if (audit) {
                            this.layout.push(audit);
                        }
                    } else {
                        debugger;
                    }
                }
                this.importSuccess = true;
            } else {
                this.importSuccess = false;
            }
        },
    })
    layout: any = [];

    arlAccountingCompanyOwnerId: string = "";

    forSituation: boolean = false;

    swapRow(index1, index2) {
        this.layout[index1] = this.layout.splice(index2, 1, this.layout[index1])[0];
    }

    removeRow(index) {
        if (index >= 0 && index < this.layout.length) {
            this.layout.splice(index, 1);
        } else {
            debugger;
        }
    }

    windowTitle() {
        if (this.addAuditDialogStep === "existingAudits") {
            return "Ajout d'un contrôle";
        } else if (this.auditToDisplay) {
            return "Affichage d'un contrôle";
        } else {
            return "Création d'un contrôle";
        }
    }

    isValidateDisabled() {
        if (this.addAuditDialogStep === "existingAudits") {
            return true;
        }
    }

    toggleAddAuditTitleDialog() {
        this.addAuditTitleDialog = !this.addAuditTitleDialog;
    }

    toggleAddAuditDialog() {
        this.addAuditDialog = !this.addAuditDialog;
    }

    toggleEditMode() {
        this.editMode = !this.editMode;
    }

    toggleDisplayMode() {
        this.displayMode = !this.displayMode;
    }

    validateNewTitle() {
        this.layout.push(this.newTitle);
        this.newTitle = { type: "cycleTitle", cycleTitle: "" };
        this.toggleAddAuditTitleDialog();
    }

    editTitleRow(index) {
        this.toggleAddAuditTitleDialog();
        this.newTitle.cycleTitle = this.layout[index].cycleTitle;
        this.index = index;
        this.toggleEditMode();
    }

    validateModificatedTitleRow() {
        this.layout[this.index] = {
            ...this.layout[this.index],
            cycleTitle: this.newTitle.cycleTitle,
        };
        this.index = 0;
        this.toggleAddAuditTitleDialog();
        this.toggleEditMode();
    }

    previous() {
        this.addAuditDialogStep = "existingAudits";
        this.auditToDisplay = null;
        this.auditToEdit = null;
        this.newAuditToAdd = null;
    }

    addAuditCheck(item) {
        this.layout.push(item);
        this.toggleAddAuditDialog();
    }

    displayExistingAudit(audit) {
        this.addAuditDialogStep = "createAudit";
        this.auditToDisplay = audit;
        this.readOnly = true;
    }

    displaySelectedAudit(audit) {
        this.addAuditDialogStep = "createAudit";
        this.toggleAddAuditDialog();
        this.auditToDisplay = audit;
        this.readOnly = true;
        this.toggleDisplayMode();
    }

    validateNewAudit() {
        //@ts-ignore
        this.$refs.auditCheckEdition.validateNewAudit();
    }

    modifyAudit(item) {
        this.layout[this.index].key = item.key;
        this.layout[this.index].modified = true;
        this.layout[this.index].title = item.title;
        this.layout[this.index].type = item.type;
        this.layout[this.index].data.form.tables[0].rows = [...item.data.form.tables[0].rows];
        this.layout[this.index].data.options = JSON.parse(JSON.stringify(item.data.options));
        this.layout[this.index].data.accountableAccounts = item.data.accountableAccounts.length
            ? [...item.data.accountableAccounts]
            : [];
    }

    validateModificatedAuditRow() {
        // @ts-ignore
        this.$refs.auditCheckEdition.validateModificatedAuditRow();
        this.toggleAddAuditDialog();
    }

    editAuditRow(audit, index) {
        this.addAuditDialogStep = "createAudit";
        this.index = index;
        this.auditToEdit = audit;
        this.toggleAddAuditDialog();
        this.toggleEditMode();
    }

    async upsertAuditCheck(audit) {
        let key = "";
        if (!audit.key) {
            key = crypto.randomBytes(12).toString("hex");
        } else {
            key = audit.key;
        }

        const result = await this.$apollo.mutate({
            mutation: UPSERT_AUDIT_CHECK,
            variables: {
                accountingFirmId: this.accountingFirmId,
                key: key,
                data: audit.data,
                title: audit.title,
                type: audit.type,
                scope: "accountingPeriodClosing",
            },
        });

        return key;
    }

    async upsertAccountingReviewLayout() {
        const items = [];
        for (const audit of this.layout) {
            let key = audit.key;
            if (audit.type === "cycleTitle") {
                items.push(audit);
            } else {
                key = await this.upsertAuditCheck(audit);
                items.push({
                    type: "audit",
                    key,
                });
            }
        }

        const result = await this.$apollo.mutate({
            mutation: UPSERT_ACCOUNTING_REVIEW_LAYOUT,
            variables: {
                id: this.id,
                name: this.accountingReviewLayoutName,
                companyScopeId: this.scopeId,
                layout: {
                    items: items,
                },
                forSituation: this.forSituation,
                accountingFirmId: this.accountingFirmId,
            },
        });
        if (result) {
            this.$router.push({ name: "AccountingReviewLayoutsTable" });
        }
    }

    validationBobby() {
        this.validationForAllAccountingCompany = true;
        this.upsertAccountingReviewLayout();
    }

    devalidationBobby() {
        this.validationForAllAccountingCompany = false;
        this.upsertAccountingReviewLayout();
    }

    duplicateAccountingReviewLayout() {
        this.$router.push({
            name: "AccountingReviewLayout-new-duplicate",
            params: { idToDuplicate: this.id },
        });
    }
}

export default toNative(AccountingReviewLayout);
</script>

<style>
.sticky-card {
    position: sticky;
    top: 0;
    z-index: 1000;
    background-color: white;
}
</style>
